const PIXEL_ID_KEY = "fb_pixel_id";

declare global {
    interface Window {
        fbq?: ( ...args: any[] ) => void;
        _fbq: any;
    }
}

export function getPixelId(): string {
    if ( typeof window === "undefined" ) return "";
    return localStorage.getItem( PIXEL_ID_KEY ) || "";
}

export function setPixelId( id: string ): void {
    if ( typeof window === "undefined" ) return;
    localStorage.setItem( PIXEL_ID_KEY, id );
}

/** 从 URL 提取 pixelid 并存储到 localStorage，如果 URL 没有则保留已有值 */
export function initPixelIdFromUrl(): string {
    if ( typeof window === "undefined" ) return "";
    const url = new URL( window.location.href );
    const urlPixelId = url.searchParams.get( "pixelid" );
    if ( urlPixelId ) {
        setPixelId( urlPixelId );
        return urlPixelId;
    }
    return getPixelId();
}

/** 读取指定 cookie 值 */
export function getCookie( name: string ): string {
    if ( typeof document === "undefined" ) return "";
    const match = document.cookie.match( new RegExp( "(^|;\\s*)" + name + "=([^;]*)" ) );
    return match ? decodeURIComponent( match[2] ) : "";
}

/** 动态注入 Facebook Pixel 基础脚本并初始化 */
export function initFacebookPixel( pixelId: string ): void {
    if ( typeof window === "undefined" || !pixelId ) return;
    if ( window.fbq ) {
        // 已初始化过，直接 init 新的 pixel id
        window.fbq( "init", pixelId );
        window.fbq( "track", "PageView" );
        return;
    }

    // 注入 FB Pixel 基础代码

    ( function( f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any ) {
        if ( f.fbq ) return;
        n = f.fbq = function( ...args: any[] ) {
            n.callMethod ? n.callMethod( ...args ) : n.queue.push( args );
        };
        if ( !f._fbq ) f._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = "2.0";
        n.queue = [];
        t = b.createElement( e );
        t.async = true;
        t.src = v;
        s = b.getElementsByTagName( e )[0];
        s.parentNode.insertBefore( t, s );
    } )( window, document, "script", "https://connect.facebook.net/en_US/fbevents.js" );

    window.fbq!( "init", pixelId );
    window.fbq!( "track", "PageView" );
}
